import React from 'react'
import {
  ModalContent,
  ModalTitle,
  ModalFooter,
  Button,
  Paragraph,
} from 'suomifi-ui-components'
import { observer } from 'mobx-react'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

function loadPage(path: string) {
  return () => {
    window.document.location.href = path
    return false
  }
}

interface GenericErrorDialogContentProps {
  dataTestId: string
}

export const GenericErrorDialogContent = observer(
  ({ dataTestId }: GenericErrorDialogContentProps): React.JSX.Element => {
    const {
      common: { lang: currentLanguage },
    } = useStore()
    const labelledby = 'generic-error-title'
    const describedby = 'generic-error-description'
    return (
      <React.Fragment>
        <ModalContent
          role="alert"
          aria-labelledby={labelledby}
          aria-describedby={describedby}
        >
          <ModalTitle data-test-id={`${dataTestId}-genericErrorHeader`}>
            <LocalizedString stringKey="genericErrorHeader" />
          </ModalTitle>
          <Paragraph id={describedby}>
            <LocalizedString stringKey="genericErrorMessage" />
          </Paragraph>
        </ModalContent>
        <ModalFooter>
          <Button
            data-test-id={`${dataTestId}-main-page-button`}
            onClick={loadPage(`/${currentLanguage}`)}
          >
            <LocalizedString stringKey="genericErrorReloadPage" />
          </Button>
        </ModalFooter>
      </React.Fragment>
    )
  }
)
